import React, { useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import DataControls from './DataControls';
import TabsContent from './TabsContent';
import CDCHeader from './CDCHeader';
import SVIbanner from './SVIBanner';
import ViewControls from './ViewControls';
import Tablist from './Tablist';
import MobileMenu from './MobileMenu';
import ErrorModal from './ErrorModal';
import MessageModal from './MessageModal';
import { UnlessIE } from '../controller/IfIE';
import { Analytics } from '../controller/Analytics';
import MapTitle from './MapTitle';
import Legend from './Legend';

var scrolled = false;
//ΔVΔVΔ: make update when interface loads
const Interface = () => {
    const { tab, openMenu } = useContext(InterfaceContext);

    if (window.location.hash === '#more-pcm' && !scrolled) {
        scrolled = true;
        document.body.classList.add('resize-on-tab-change');
        setTimeout(() => {
            var link = document.querySelector('[name=preparedcountymaps]');
            var y = link.getBoundingClientRect().y;
            document.body.scrollTop = y;

            window.scroll({
                top: y,
                behavior: 'smooth'
            });
        }, 500);
    }
    return (
        <>
            <div id="pop-ups">
                <ErrorModal />
                <MessageModal />
                <div className="printwrap">
                    <div className="printing">
                        <MapTitle />
                        <div id="printCanvas"></div>
                        <Legend />
                    </div>
                </div>
            </div>
            <div id="interface" className={`${openMenu ? 'open-menu' : 'closed-menu'} tab-${tab.slug}  embed`}>
                <UnlessIE>
                    <Analytics />
                    <CDCHeader />
                    <SVIbanner />
                    <DataControls type={tab} />
                    <ViewControls type={tab} />
                    <Tablist />
                    <MobileMenu type={tab} />
                    <TabsContent />
                </UnlessIE>
            </div>
        </>
    );
};
export default Interface;
